export default "__VITE_ASSET__3e508144__"